/**
 * Formata um número como moeda brasileira (padrão) ou conforme opções fornecidas
 * @param number - Número a ser formatado
 * @param locale - Locale para formatação (padrão: "pt-BR")
 * @param options - Opções de formatação do Intl.NumberFormat (padrão: currency BRL)
 * @returns String formatada ou "R$ 0,00" em caso de número inválido
 */
export function numberFormat(
  number: number,
  locale = "pt-BR",
  options: Intl.NumberFormatOptions = { style: "currency", currency: "BRL" }
): string {
  // Valida se o número é válido
  if (typeof number !== "number" || isNaN(number) || !isFinite(number)) {
    return "R$ 0,00";
  }

  // Garante que currency seja sempre "BRL" quando style for "currency"
  const formatOptions: Intl.NumberFormatOptions = {
    ...options,
    ...(options.style === "currency" && { currency: "BRL" }),
  };

  return number.toLocaleString(locale, formatOptions);
}

/**
 * Remove a formatação de um número formatado e retorna o valor numérico
 * @param numberFormatted - String com número formatado (ex: "R$ 1.234,56")
 * @returns Número sem formatação ou 0 em caso de erro
 */
export function numberRemoveFormat(numberFormatted: string): number {
  // Valida entrada
  if (!numberFormatted || typeof numberFormatted !== "string") {
    return 0;
  }

  try {
    // Remove "R$" e espaços
    let cleaned = numberFormatted.replace(/R\$\s*/g, "").trim();

    // Se estiver vazio após limpeza, retorna 0
    if (cleaned === "") {
      return 0;
    }

    // Remove todos os pontos (separadores de milhar) e substitui vírgula por ponto
    cleaned = cleaned.replace(/\./g, "").replace(",", ".");

    // Tenta fazer parse
    const parsed = parseFloat(cleaned);

    // Retorna 0 se o parse falhar ou resultar em NaN
    return isNaN(parsed) ? 0 : parsed;
  } catch {
    // Em caso de qualquer erro, retorna 0
    return 0;
  }
}
